import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MerchantService } from '../../_services/fundraising/merchant.service';

@Component({
  selector: 'app-merchant-portal',
  templateUrl: './merchant-portal.component.html',
  styleUrls: ['./merchant-portal.component.css']
})
export class MerchantPortalComponent implements OnInit {

  constructor(
    private merchantService: MerchantService,
    private router: Router) { }

  ngOnInit(): void {
    this.merchantService.logout();
    localStorage.setItem('portal-type', 'portal');
    this.router.navigate(['/merchant-login']);
  }

  logout() {
    this.merchantService.logout();
    localStorage.setItem('portal-type', 'merchant');
    this.router.navigate(['/merchant-login']);
  }


}
